import { render, staticRenderFns } from "./ExternalMent.vue?vue&type=template&id=4af125de"
import script from "./ExternalMent.vue?vue&type=script&lang=js"
export * from "./ExternalMent.vue?vue&type=script&lang=js"
import style0 from "./ExternalMent.vue?vue&type=style&index=0&id=4af125de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports